import React from "react";
import styled from "styled-components";
import Tabs, { Tab } from "react-best-tabs";
import "react-best-tabs/dist/index.css";
// Assets
import aboutimg from "../../assets/img/img_business.jpg";
import aboutimg1 from "../../assets/img/OurPeopleAndInfrastructure.jpg";
import img1 from "../../assets/img/rajesh_handa_img.jpg";
import img2 from "../../assets/img/heema_handa_img.jpg";
import img3 from "../../assets/img/AbdulkhaderPattillath.jpg";
import img4 from "../../assets/img/AmitVarma.jpg";
import img5 from "../../assets/img/sundip.jpg";
import img6 from "../../assets/img/ajay_sheth.png";
import DrGKSingh from "../../assets/img/DrGKSingh.jpg";
import ProfHSDhami from "../../assets/img/ProfHSDhami.jpg";
import DrNimmiRastogi from "../../assets/img/DrNimmiRastogi.jpg";
import DrRCJoshi from "../../assets/img/DrRCJoshi.jpg";
export default function Services() {
  return (
    <Wrapper id="services">
      <div className="whiteBg" style={{ padding: "60px 0 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold text-center mb-20">Who we are</h1>
            <Tabs
              activeTab="1"
              className=""
              ulClassName=""
              activityClassName="bg-success"
              onClick={(event, tab) => console.log(event, tab)}
            >
              <Tab title="At a Glance" className="mr-3">
                <div className="mt-3">
                  <p>
                    We are a group of next generation technology & program
                    management companies delivering solutions and services built
                    around intellectual property. We are a group of companies
                    and has created niche and ability to provide and distribute
                    value across industry verticals using innovative
                    technologies and program management in various Industry
                    Verticals thus delivering state of the art domain based
                    eco-solutions. Our eco-solutions provide corporate,
                    businesses and government a Turnkey Solution Provider
                    approach by securing data privacy and state of the art
                    technology and non-technology platforms on various connected
                    objects, onsite and on cloud and in between business
                    functionalities. We specialized in our Turnkey Provider
                    approach specially in Health Care sector keeping in mind
                    that the hospitals and health care provider get the highest
                    possible ROI from healthcare infrastructure investments. As
                    a turnkey provider in health care sector our objective is to
                    provide business value.
                  </p>
                  <br />
                  <p className="text-center">
                    <img className="w-100" alt="img" src={aboutimg} />
                  </p>
                  <br />
                  <h4>Our Mission</h4>
                  <p>
                    Shripati Group organizations mission is to support
                    digitization and automations making governments and private
                    service providers our partners while delivering services to
                    citizens in providing
                    <strong>
                      "Robust interoperability platform catering to the needs of
                      same sets of citizens"
                    </strong>
                    providing values for businesses by protecting citizens and
                    business users their identity and data at anywhere and
                    everywhere.
                  </p>

                  <h4 className="mt-20">Our Philosophy</h4>
                  <p>
                    Shripati Group is relatively young group but as a
                    professional experience leaders associated with our group
                    has more than three decades of history with unique strength
                    and niche in providing solutions and products for various
                    verticals. While maintaining and extending its leadership in
                    providing right fit Innovative and niche solution, we have
                    also built unique strengths in providing business consulting
                    and mission critical solutions in various Lines of
                    Businesses (LOBs) across verticals such as Education, Health
                    care and e-Commerce with dedicated organizations Products
                    and services.
                  </p>
                  <p>
                    We have provided and providing consistently business and
                    technology solutions tailored to wide range of industries.
                    Our customers benefit from our collaborative and solution
                    centric approach that gives us ability to manage highly
                    complex programs and provide leading turnkey solution to our
                    customers.
                  </p>
                  <p>
                    We believe that a portfolios of inflexible technology
                    outsourcing driven by tactical cost cuttings will not
                    address the changes in the current economic and business
                    conditions. We also believe that the success in today's
                    environment will only come to those who understand the full
                    range of industry vertical, understand to give business a
                    thrust with technology platform along with know-how for the
                    end customer strategic and financial requirements from
                    technology.
                  </p>
                  <p>
                    We have in place a set of guiding principles and a
                    philosophy to manage this extensive change. As an Agile,
                    Responsive and Flexible organization we are equipped to
                    effectively manage the environment and our philosophy frame
                    work is based on
                  </p>
                  <ul className="list">
                    <li>Management Commitment </li>
                    <li>Employee Empowerment </li>
                    <li>Customer focus </li>
                    <li>Management by Facts </li>
                    <li>Continual Improvements </li>
                  </ul>
                  <p>
                    In a world full of promises and efforts, we value
                    commitments and are driven by top management of an
                    organization and is honored by entire organization.
                  </p>
                  <p>
                    In a world full of competencies and skills, business
                    deliveries and behavioral we value empowerment and moral
                    values to employees who can create the world finest
                    organization.
                  </p>
                  <p>
                    In a world full of market spaces and discrete services, we
                    value Customer and solution centricity so that value is
                    created and distributed.
                  </p>
                  <p>
                    In a world full of relationships be it with employees,
                    customers, partners or stakeholders, we value facts based on
                    reliability, quality, robustness and speed so that the
                    foundation of trust, transparency and flexibility is
                    delivered.
                  </p>
                  <p>
                    In a world full of markets rapidly approaching point of
                    inflection (the point where the volume and value
                    proportionality would change). We value continual
                    improvements to cater new services and aspire to focus on
                    value.
                  </p>
                  <h4 className="mt-20">Our People & Infrastructure</h4>
                  <p className="text-center">
                    <img className="w-100" alt="img" src={aboutimg1} />
                  </p>
                  <h4>Certifications</h4>
                  <p>
                    Solutions & Services quality management systems are
                    compliance with
                  </p>
                  <h5>ISO 9001-2008</h5>
                  <p>
                    The Quality Management System is established and documented
                    as per the structure adopted as per quality manual of
                    Shripati group and implemented and maintained by
                    concerned/relevant personnel of group organizations. A
                    process interaction matrix (Quality Plan) defines the
                    various operational processes, sequence and interaction of
                    laid down processes. Each process/procedures incorporates
                    criteria, methods and control measures to achieve planned
                    results and for continual improvement. Necessary resources
                    and information are provided to support the operation and
                    monitoring of these processes. Monitoring and measurements
                    to achieve SERVICE conformity have been identified and
                    implemented as per ISO 9001-2008 standards.
                  </p>
                  <h5>ISO 27001-2005</h5>
                  <p>
                    <u>Information Security Management System (ISMS) Policy</u>
                  </p>
                  <p>
                    We are committed to preserve the confidentiality, integrity
                    and availability of information provided to us or with us,
                    <em>
                      in providing the services of Off Site Document and Data
                      storage, Imaging, Data Capturing, Disaster recovery
                      including Online Data Storage and Business Continuity
                      management services to increase the confidence of our
                      valued customers /partners by:
                    </em>
                  </p>
                  <ul className="list">
                    <li>
                      Applying Information Security controls on all Information
                      Assets.
                    </li>
                    <li>Risk assessment at suitable intervals.</li>
                    <li>Prompt mitigation Actions against risk criteria. </li>
                    <li>Educating all concerned members. </li>
                    <li>Meeting Legal requirements.</li>
                  </ul>
                  <p>
                    We shall review the effectiveness of the ISMS Policy in
                    order to make suitability of the system and its continual
                    improvement.
                  </p>
                  <p>
                    <u>Information Security (IS) objectives</u>
                  </p>
                  <ul className="list">
                    <li>Identify security requirements.</li>
                    <li>
                      Reduce the risk of theft, or misuse of facilities by
                      educating the employees.
                    </li>
                    <li>
                      Ensuring that the information system security incidents
                      are promptly reported.
                    </li>
                    <li>
                      Ensuring that the responsibilities are defined for
                      implementation and operating. Information security
                      management system (ISMS).
                    </li>
                  </ul>
                </div>
              </Tab>
              <Tab title="Leadership" className="mr-3">
                <div className="mt-3">
                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Rajesh Handa" src={img1} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Rajesh Handa</p>
                          <p className="job-title">
                            Promoter Director &amp; CEO
                          </p>
                          {/* <div className="social">
                            <ul className="inline-list">
                              <li>
                                <a
                                  className="btn-floating"
                                  href="https://www.facebook.com/handa.rajesh.5"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="fa fa-facebook"></i>
                                </a>
                                &nbsp;
                                <a
                                  className="btn-floating"
                                  href="https://twitter.com/RajeshHanda11"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="fa fa-twitter"></i>
                                </a>
                                &nbsp;
                                <a
                                  className="btn-floating"
                                  href="https://in.linkedin.com/in/rajeshhanda"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="fa fa-linkedin"></i>
                                </a>
                                &nbsp;
                              </li>
                            </ul>
                          </div> */}
                        </div>
                        <div className="featured-details">
                          <p>
                            Mr. Rajesh Handa is an Alumnus of NIT, Jamshedpur
                            and holds a degree in Masters of Computers
                            Application and MBA from Liverpool university UK. He
                            has over twenty eight years of experience in
                            delivering and managing Technology and Strategic
                            business consulting mandates, Extensive Knowledge of
                            Program & projects management, Technologies & system
                            integrations, Software Design & development
                            methodologies .Worked with many Multinational
                            companies as Delivery and business Heads , Vice
                            President and COO with some well-known names like ST
                            Microelectronics, Frazer Williams Data Systems KIPCO
                            Group (Kuwait) and delivered services as per
                            Customer satisfaction. Good leadership and People
                            Management skills, mentoring people to deliver and
                            act as a leader. As a senior member of the
                            Organization, the primary responsibility is to
                            deliver programs and large projects, define
                            enterprise-wide strategy for projects and consulting
                            assignment deliveries and strategy along with
                            marketing collaterals for various geographies and
                            regions and develop enterprise wide advisory and
                            technology services go-to market plans along with
                            sales projections.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Heema Handa" src={img2} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Heema Handa</p>
                          <p className="job-title">Co-Promoter Director</p>
                        </div>
                        <div className="featured-details">
                          <p>
                            Ms. Hema Handa is an alumnus of SRCC Delhi
                            University and takes care of Human Resources in
                            Group Organizations and Relationship with Banking &
                            Financial Institutes. She is instrumental in
                            establishing employee friendly culture for Shripati
                            group and established many meaningful relationships
                            with Banking Industry by getting Products and
                            Services of Shripati group interfaced with Banking &
                            Financial Platform. Prior To Joining Shripati Group
                            she was associated with HSBC and has more than two
                            decades of banking experience. During her long
                            career span she has worked in many important areas
                            of banks which include Trade & Finance, Treasury,
                            Retail, Corporate Banking, Audits & Compliances and
                            many more. She is been awarded with many awards and
                            one of them being a best employee award from HSBC.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Heema Handa" src={img5} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Sundip Kumar</p>
                          <p className="job-title"></p>
                        </div>
                        <div className="featured-details">
                          <p>
                            An executive leader with B. Tech Degree having
                            versatile skills and over 20 successful years of
                            business journey with a strong, rich and varied
                            business experience across various domains in the
                            field of e-Governance, IT & ITeS, Information and
                            Communication Technology (ICT) industry. With more
                            than 15 years' experience of managing sales, pre
                            sales and business development activities, excellent
                            understanding of Government and Public sector
                            business in India. Believes in tight, yet light
                            business environment and strong relationships. He
                            has delivered industry leading performance by
                            focusing on management stability, and a
                            collaborative and participatory leadership style
                            with a razor-sharp focus on execution.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Heema Handa" src={img6} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Ajay Sheth</p>
                          <p className="job-title"></p>
                        </div>
                        <div className="featured-details">
                          <p>
                            An executive leader with B. Tech. and is Associated
                            with Health Care Industry with more than 30 years of
                            experience. His vast experience for health care
                            industry Information management is really
                            appreciable as he has been instrumental in more than
                            100 implementations of Hospital information
                            Management System for Hospitals in INDIA and MENA
                            region. An energetic Professional with strong work
                            ethics, ready to take on new challenges, accepts
                            responsibility & accountability. Excellent
                            Man-manager and team leader, but also a receptive
                            team player. Builds a highly motivated, cohesive
                            team. believes in delegation, to allow the
                            subordinates to manage their own operations, yet
                            works in close contact with them. Ability to
                            formulate and implement plans, both short term and
                            long term and with good interpersonal skills.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              <Tab title="Board of Advisors" className="mr-3">
                <div className="mt-3">
                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Abdulkhader Pattillath" src={img3} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Abdulkhader Pattillath</p>
                          <p className="job-title">Group Director </p>
                        </div>
                        <div className="featured-details">
                          <p>
                            Mr. Pattillath is a Group Director - Information
                            Technology at ACICO Group, Kuwait from July 2016
                            till date. Prior to his current assignment he served
                            as Regional IT Director at LSH Holding Co. (Part of
                            Al Humaizi Group of company, Kuwait) from Year 2010
                            till June 2016. He also served as a Group IT Manager
                            at KIPCO Group companies, Kuwait and at Gulf Bank.
                            He is holding a Bachelor's Degree, Computer
                            Information Systems from Devry University –Ohio USA
                            and is a certified PMP, CISA, ITIL professional with
                            business acumen who believes that technology should
                            first and foremost raise the bottom line. He
                            specializes in generating income by maximizing
                            efficiencies and keeping a sharp eye on budget
                            expenditures, while keeping end users &amp;
                            stakeholders happy. His innovative ideas blended
                            with business applications are widely appreciated
                            internationally. He is having a several years of
                            technology hands-on experience with Unix, Windows
                            Servers, VMware, Exchange, Oracle/SQL Databases,
                            Islamic banking solutions – including core banking
                            ,Retail Systems and delivery channels, Document
                            Management Systems , Oracle/Microsoft ERP
                            applications, Security technologies, multiple
                            locations / remote computing and Disaster recovery
                            sites implementation.
                          </p>
                          <p>
                            He represents many International forums in MENA
                            geography and is a well-known face of an Information
                            Technology Industry in Kuwait.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Dr. Amit Varma" src={img4} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Dr. Amit Varma</p>
                          <p className="job-title">
                            Professor and Head, Department of Medicine
                          </p>
                        </div>
                        <div className="featured-details">
                          <p>
                            Dr. Amit Varma is currently working as Professor and
                            Head, Department of Medicine at SGRR Institute of
                            Medical and Health Sciences, State of Uttarakhand
                            and instrumental in bringing innovative Technology
                            for Medical and Health Sciences in SGRRI. Prior to
                            this Assignment he was Professor and Head ,
                            Department of Medicine at Himalayan Institute of
                            Medical science , Jolly Grant Dehradun . He holds
                            MBBS, MD (Medicine), FICP, FACP (USA),
                            FRCP(Edinberg) and is a recipient of many awards and
                            an author of many journals which includes
                          </p>

                          <ul className="list">
                            <li>
                              Recipient of Shyama Krishna Memorial National
                              Award 2017
                            </li>
                            <li>
                              Recipient of Award of Excellence by the Governor
                              of Uttarakhand 2017
                            </li>
                            <li>
                              Recipient of President Appreciation Award, IMA{" "}
                            </li>
                            <li>
                              Fellow of Indian College of Physician (FICP)
                            </li>
                            <li>
                              Fellow of American College of Physicians (FACP)
                            </li>
                            <li>
                              Fellow of Royal College of Physicians (FRCP)
                              Edinderg
                            </li>
                            <li>Founder and President, UDAAN Foundation</li>
                            <li>
                              Founder and President of South East Asia Diabetes
                              Foundation
                            </li>
                            <li>
                              Founder and Chief Editor Journal of South East
                              Asia Medical Clinics
                            </li>
                            <li>
                              Life Member Association of Physicians of India
                              (API)
                            </li>
                            <li>
                              Life Member Indian Medical Association (IMA)
                            </li>
                            <li>Life Member RSSDI</li>
                            <li>Member Editorial Board API 2017</li>
                            <li>Faculty API 2017</li>
                            <li>
                              Presented more than 150 papers in various National
                              and International conferences
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Dr. GK Singh" src={DrGKSingh} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Dr. G. K. Singh</p>
                          <p className="job-title">Ex. Director AIIMS, Patna</p>
                        </div>
                        <div className="featured-details">
                          <p>
                            Prof. (Dr.) G. K. Singh son of Padamshri Prof. (Dr.)
                            Rajendra Vir Singh is an Ex. Director AIIMS, Patna
                            (An institute of excellence) and served the same
                            from 2011 till October 2016 and is currently leading
                            an important medical Institute KGMU, Lucknow. He has
                            played a pivotal role in establishing AIIMS, Patna
                            from scratch and infact contributed to creating
                            consensus to create six (06) new AIIMS in 2012 by
                            promulgating the act, modifying act AIIMS act 1956
                            to enliven Six (06) new AIIMS. He is rated amongst
                            one of the best Medical services administrator and
                            has had an outstanding Academic and teaching career
                            in the field of medical education in India &amp;
                            abroad. He did his MBBS Honors from KGMC, Lucknow
                            and was the Hewett Gold Medalist ,Secured BN Sinha
                            gold medal for the best post graduate thesis He also
                            hold a Master’s degree in Orthopedics from KG
                            Medical College, Lucknow, A Master's degree in
                            Clinical Epidemiology from University of
                            Pennsylvania, USA (an Ivy League University), a
                            Diplomat of National Board in Physical Medicine and
                            Rehabilitation, a PG Diploma in Hospital Management
                            and a Fellowship of International College of
                            Surgeons giving a strong theoretical background. His
                            Filed of specialization includes Orthopedics,
                            Physical medicines &amp; rehabilitation and clinical
                            epidemiology. He is having a hands on experience in
                            strategy, planning, policy execution, feedback and
                            optimization of policy, facets needed as a Director
                            and a visionary administrator.
                          </p>
                          <p>
                            He Served as Government of India Advisor to BP
                            Koirala Institute of Health Sciences, Nepal (a 2300
                            Crore project) for all academic, research, patient
                            care and development activities. He was among few
                            Indian to represent Government of India and Indian
                            Medical Faculty in International Medical Science
                            University built by any country for another country.
                            He is having a vast experience as a medical
                            professional to deal with medical emergencies worked
                            in the capacity of Medical Superintendent at KGMU,
                            the largest hospital in South East Asia with 2,360
                            beds, orthopedic units of the trauma centers at
                            KGMU, Director Institute of Clinical Epidemiology
                            CSM Medical University Lucknow, Professor and
                            Associate professor with many reputed medical
                            universities.
                          </p>
                          <p>
                            He has many awards, honors and recognition in his
                            feather and some of them are listed below:
                          </p>

                          <ul className="list">
                            <li>Topped in the 71-75 KGMC MBBS Batch</li>
                            <li>
                              Won 17 Gold Medals and 35 Academic Prizes at UG
                              Level
                            </li>
                            <li>
                              5th Student in the History of KGMC (1911-1975) to
                              have passed MBBS with Honors
                            </li>
                            <li>
                              Created a tele medical education site to educate
                              common man in dealing with medical emergency and
                              disaster
                            </li>
                            <li>
                              Created a unique net based audio visual
                              communication between common men stationed in a
                              village seeking medical advice from AIIMS Patna
                            </li>
                            <li>
                              Video mapped the 34 year old annual 2012 AES
                              Japanese encephalitis epidemic in UP and Bihar
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="H. S. Dhami" src={ProfHSDhami} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Prof. H. S. Dhami</p>
                          <p className="job-title">
                            Vice Chancellor of Kumaon University
                          </p>
                        </div>
                        <div className="featured-details">
                          <p>
                            Prof HS Dhami is a Vice Chancellor of Kumaon
                            University (Uttrakhand State University) from Year
                            2013 till date. He is also serving as an OSD of
                            Almora Residential University and National Law
                            University of Uttrakhand from year 2016. Prior To
                            his current assignments he also served as a Vice
                            Chancellor of GB Pant University of Agriculture and
                            Technology as an additional charge during 2014 and
                            2015. He is having vast administrative, academic and
                            mentoring skills and served many reputed
                            universities as Pro-Vice Chancellor, Dean (student
                            Welfare), Campus Dean, Director Information
                            Technology &amp; Communication, Controller of
                            Examination and Professor. He has done is B.Sc. from
                            Agra University in 1973, M.Sc. (Mathematics) and PHD
                            in mathematics from Kumaon University in 1978.
                          </p>

                          <p>
                            He has many awards, honors and recognition in his
                            feather and some of them are listed below:
                          </p>

                          <ul className="list">
                            <li>
                              Awarded Gold medal from PG College Pithoragarh.
                            </li>
                            <li>
                              Received “Life Time Education Award 2016” from
                              National Institute of Cleanliness Education and
                              Research (NICER - Affiliated to United
                              nations-ECOSOC, DPI, UNICEF, UNESCO ){" "}
                            </li>
                            <li>
                              Identified as “The Great Son of India” in All
                              India Conference of Intellectuals in 2016
                            </li>
                            <li>
                              Selected amongst 100 Most Influential Vice
                              Chancellor by World Education Congress awards 2016{" "}
                            </li>
                            <li>
                              Recipient of 2nd National Uttrakhand Education
                              Summit &amp; Awards 2015 of CMAI Association of
                              India for “Excellent Contribution for Education
                              Sector” from Honorable CM of Uttrakhand Shri
                              Harish Rawat.{" "}
                            </li>
                            <li>
                              Recipient of Soe Global Education awards 2014.{" "}
                            </li>
                            <li>Awarded Uttarakhand Ratan</li>
                            <li>
                              Recipient of Bharatmata award conferred by Indian
                              Institute of Oriental Heritage
                            </li>
                            <li>
                              Selected 2000 Outstanding Intellectuals of the
                              21st Century 2012 by International Biographical
                              Centre, Cambridge, England
                            </li>
                            <li>
                              Nominated for Top Intellectual minds of 2011 by
                              International Biographical Centre, Cambridge,
                              England
                            </li>
                            <li>
                              Biography included in Marquis Who's Who in the
                              World-2011 (28th edition) (America’s Biographer
                              Since 1899)
                            </li>
                            <li>
                              Academic Council member of Uttarakhand open
                              University and Doon University, Uttarakhand{" "}
                            </li>
                            <li>
                              Number of Research publications in National and
                              International Journals: 150
                            </li>
                            <li>Number of Ph.D. Students supervised: 18 </li>
                            <li>
                              Member Research Committee of H N B Garhwal
                              University (Central University)
                            </li>
                            <li>
                              Item writer, moderator and paper setter of various
                              commissions
                            </li>
                            <li>
                              Member Interview Board of Uttarakhand Public
                              Service Commission
                            </li>
                            <li>
                              Examiner of several Engineering colleges as an IT
                              expert
                            </li>
                            <li>
                              Member, Academic advisory board of Graphic Era
                              University (Deemed University) Dehradun
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Dr. Nimmi Rastogi" src={DrNimmiRastogi} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Dr. Nimmi Rastogi</p>
                          <p className="job-title">
                            M.B.B.S. DGO; PGD Obst.Sonography PGD Endoscopy ART
                          </p>
                        </div>
                        <div className="featured-details">
                          <p>
                            Dr. Nimmi Rastogi is M.B.B.S. DGO; PGD
                            Obst.Sonography PGD Endoscopy ART. She is an Advisor
                            Health to Delhi Government, Team Lead Dialogue &amp;
                            Development Commission, practicing Gynecologist and
                            Author. She is also Advisor for Mohalla Clinic
                            Steering Committee (GNCTD), and instrumental as a
                            Member for Community Health Action Group – Delhi
                            State Health Mission. She also represents a very
                            reputed Medical Centre by the name Sarthak Medical
                            Centre in the Heart of Delhi as CEO &amp; Chief
                            OBGYN since 2004 till date. She is having a vast
                            experience as a Gynecologist and worked as a senior
                            OBGYN in Critical Care Medicine.
                          </p>

                          <p>
                            She worked with many reputed Hospital as senior
                            residency &amp; Senior Gynecologist which includes
                            some of the very reputed names as Sir Ganga Ram
                            Hospital, SafdarJang Hospital (SJH), Rockland
                            Hospital, Shrimati Sucheta Kriplani Hospital (SSKH),
                            and Aakash Hospital. She is also instrumental as:
                          </p>
                          <ul className="list">
                            <li>Visiting consultant Saket City Hospital</li>
                            <li>
                              Visiting Consultant IVF wing of Fortis La Fem
                              &amp; Medicare IVF
                            </li>
                            <li>
                              Faculty : Indian Society of Assisted Reproduction
                              (ISAR) Delhi{" "}
                            </li>
                            <li>
                              Member European Society of human reproduction
                              &amp; Embryology (ESHRE){" "}
                            </li>
                            <li>
                              Member Society of Obstetric medicine of Australia
                              &amp; New Zealand (SOMANZ)
                            </li>
                            <li>
                              Chief Practitioner Infertility medicine &amp;
                              OBGYN at SMC (Since 2004 till Date){" "}
                            </li>
                            <li>
                              Ex Program Director PRAYAS for sexual health of
                              adolescent destitute girls in slums{" "}
                            </li>
                            <li>
                              On Panel of UGC as Executive member of Apex body
                              against Sexual harassment{" "}
                            </li>
                            <li>
                              Program Director of campaign to spread awareness
                              against STD launched by IMA.
                            </li>
                            <li>
                              Conceptualized Tb awareness, Breast feeding &amp;
                              Antenatal promos at DAVP
                            </li>
                            <li>
                              Executive member People's Action: Civic Advocacy
                              Group in the capital.
                            </li>
                            <li>
                              Ex. Disaster Management Team : Common Wealth Games
                              held in Delhi
                            </li>
                            <li>
                              Health awareness shows on National TV &amp; All
                              India Radio
                            </li>
                            <li>
                              Worked with multiple NGOs for promotion of
                              adolescent health
                            </li>
                            <li>
                              On panel of project CACA (Children against child
                              abuse , IIT)
                            </li>
                            <li>
                              Medical advisor : Skill development : Vivo
                              Healthcare
                            </li>
                            <li>
                              Currently working on a book about pathos of women
                              in all walks of life as seen by a doctor during
                              her counsel.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="featured-panel">
                        <div className="featured-image">
                          <img alt="Dr. R.C. Joshi" src={DrRCJoshi} />
                        </div>
                        <div className="featured-title">
                          <p className="mng-title">Dr. R.C. Joshi</p>
                          <p className="job-title">
                            Former Prof. E. &amp; C.E. Department at IIT Roorkee
                            and former Chancellor at Graphic Era University
                            Dehradun
                          </p>
                        </div>
                        <div className="featured-details">
                          <p>
                            Dr. R.C. Joshi is a Former Prof. E. &amp; C.E.
                            Department at IIT Roorkee and former Chancellor at
                            Graphic Era University Dehradun. Currently he is
                            advisor, Academic &amp; Research at GEU, Dehradun.
                            He received his B.E degree from NIT Allahabad
                            in1967, M.E .1st Div. with Honors and Ph.D. Degree
                            from Roorkee University, now IIT Roorkee, in year
                            1970 &amp; 1980 respectively. He worked as a
                            Lecturer in J.K Institute, Allahabad University
                            during 1967-68. He joined Roorkee University in 1970
                            as Lecturer, became Reader in 1980 and Prof. in
                            1987. He had been Head of Electronics &amp; Computer
                            Engineering from Jan 1991-1994 &amp; Jan. 1997 to
                            Dec. 1999.He was also the Head of Institute Computer
                            Centre, IIT Roorkee from March 1994 to Dec. 2005. He
                            also served as a short visiting Professor’s
                            Assignment in University of Cincinnati, USA,
                            University of Minnesota, U.S.A &amp; Macquarie
                            University Sydney Australia. He has also worked as a
                            Principal Investigator in number of Sponsored
                            Projects of Ministry of Information &amp;
                            Communication Technology, DRDO, AICTE, UNDP, &amp;
                            ISEA. He had taught more than 25 subjects in
                            Computer Engineering, Electronics Engineering &amp;
                            Information Technology.
                          </p>

                          <p>
                            He has many awards, honors and recognition in his
                            feather and some of them are listed below:
                          </p>

                          <ul className="list">
                            <li>
                              Dr. Joshi was selected as "Star Performer" at IIT
                              Roorkee. He was awarded Gold Medal by Institution
                              of India for Best Research Paper. His Paper along
                              with Co-authors was awarded Best Research Paper in
                              27th IEEE International Performance computing and
                              Communication Conference Austin USA 2008.
                            </li>
                            <li>
                              Dr. Joshi had been a Member/Chairman of Various
                              expert Committee like AICTE, NBA, DEC, UGC, Board
                              of Directors of Hiltron and Board of Governors of
                              various Institutions
                            </li>
                            <li>
                              Dr. Joshi has guided 27 Ph.Ds, 250 M.Tech,
                              Dissertation, 75 B.E Projects.
                            </li>
                            <li>
                              He has written 7 Books/Book Chapters and several
                              technical reports. Dr. Joshi has published more
                              than 250 Research Papers in International/National
                              Journals’/ Conferences.
                            </li>
                            <li>
                              Dr. Joshi has organized various National and
                              International Conferences. Also Chaired sessions
                              in Various Conferences like International
                              Conferences on Robotics &amp; Expert Systems in
                              Piltsburge USA, International Conference on
                              parallel Processing as St. Charles Chicago USA.
                            </li>
                            <li>
                              Dr. Joshi has delivered several special lectures
                              in various U.S Universities and Research
                              Organization like University of Detroit,
                              University of Raleigh, University Of Texas Dallas
                              Austin, University of Florida, Amolo Research
                              Centre, University of Minnesota, and University of
                              Cincinnati etc.
                            </li>
                            <li>
                              He also delivered Ramanujan Memorial lecture on
                              “Personal Identification” and Verification using
                              Biometric, Smartcard and Bluetooth Technology at
                              IIT Roorkee. He conducted various courses in
                              continuing Education Department and Institute
                              Computer Centre at IIT Roorkee.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
            </Tabs>

            <br></br>
          </HeaderInfo>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;

const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
